import React, { useState } from "react";
import { Grid, Stack} from "@mui/material";
import { Colors, Direction } from "../../../_app/types";
import { Strategy } from "../../../store/slices/strategySlice";
import AutoStrategyRange from "./AutoStrategyRange";
import CustomPaper from "../../../_components/CustomPaper";
import AdronTypography from "../../../_components/AdronTypography";
import OverlayTooltip from "../../../components/OverlayTooltip/OverlayTooltip";
import TooltipDirectionContent from "../../../components/TooltipDirectionContent/TooltipDirectionContent";
import IconComponent from "../../../_components/IconComponent";
import SwitchField from "../../../_components/SwitchField";

interface Props {
  strategy: Strategy;
  onChangeDirection: (value: Direction) => void;
  onChangeMinPrice: (value: number) => void;
  onChangeMaxPrice: (value: number) => void;
  onChangeStartPrice: (value: number) => void;
}

const AutoStrategyRangeSettings = ({
  strategy,
  onChangeDirection,
  onChangeMaxPrice,
  onChangeMinPrice,
  onChangeStartPrice,
}: Props) => {
  const [directionTooltipOpen, setDirectionTooltipOpen] = useState<boolean>(false);
  const [position, setPosition] = useState({ top: 0, left: 0 });

  const handleOpen = () => {
    setDirectionTooltipOpen(true);
  };

  return (
    <>
      <Grid container direction="column" spacing={3} sx={{ paddingBottom: 3, paddingTop: 2 }}>
        <Grid item>
          <CustomPaper sx={{ padding: "12px !important" }}>
            <Stack
              direction={"row"}
              alignItems={"center"}
              spacing={"3px"}
              sx={{ marginBottom: "5px" }}
              onClick={() => handleOpen()}
            >
              <AdronTypography value="Direction" halfOpacity />
              <OverlayTooltip placement="top-end" title={<TooltipDirectionContent />}>
                <IconComponent iconName={"Question"} hasStroke />
              </OverlayTooltip>
            </Stack>
            <SwitchField
              value={strategy.gridDirection}
              onChange={onChangeDirection}
              paramList={[
                {
                  label: "Short",
                  icon: <IconComponent iconName={"TradeDown"} hasFill />,
                  color: Colors.Destructive,
                },
                {
                  label: "Long",
                  icon: <IconComponent iconName={"TradeUp"} hasFill />,
                  color: Colors.Success,
                },
              ]}
            />
          </CustomPaper>
        </Grid>
        <Grid item>
          <AutoStrategyRange
            strategy={strategy}
            onChangeMinPrice={onChangeMinPrice}
            onChangeMaxPrice={onChangeMaxPrice}
            onChangeStartPrice={onChangeStartPrice}
          />
        </Grid>
      </Grid>
    </>
  );
};

export default AutoStrategyRangeSettings;
